<div class="inputRow" [ngClass]="{'inputRowMobile': isMobile}" *ngIf="form">
  <mat-form-field class="flex1" id="firstName">
    <mat-label>{{'PROFILE.FIRST_NAME_INPUT_PLACEHOLDER' | translate}}</mat-label>
    <input type="text" matInput [formControl]="firstName" autocomplete="off" placeholder="" [ngClass]="{'errorBorder': firstName?.errors?.['required'] && firstName?.dirty}" />
    <mat-error *ngIf="firstName?.errors?.['required']">{{'ERROR.REQUIRED' | translate}}</mat-error>
  </mat-form-field>
  <mat-form-field class="flex1" id="lastName">
    <mat-label>{{'PROFILE.LAST_NAME_INPUT_PLACEHOLDER' | translate}}</mat-label>
    <input type="text" class="lastNameInput" matInput [formControl]="lastName" autocomplete="off" placeholder="" [ngClass]="{'errorBorder': lastName?.errors?.['required'] && lastName?.dirty,'lastNameMobileInput' : isMobile}"/>
    <mat-error *ngIf="lastName?.errors?.['required']">{{'ERROR.REQUIRED' | translate}}</mat-error>
  </mat-form-field>
</div>
<div class="inputRow" [ngClass]="{'inputRowMobile': isMobile, 'inputRowMobileLast': isMobile}">
  <mat-form-field class="flex1" id="email">
    <mat-label>{{'PROFILE.EMAIL_INPUT_PLACEHOLDER' | translate}}</mat-label>
    <input type="text" matInput [formControl]="email" autocomplete="off" placeholder="" [ngClass]="{'errorBorder': (email?.errors?.['required'] || email?.errors?.['pattern']) && email?.touched}"/>
    <mat-error *ngIf="email?.errors?.['pattern']">{{'ERROR.INVALID_EMAIL' | translate}}</mat-error>
    <mat-error *ngIf="email?.errors?.['required']">{{'ERROR.REQUIRED' | translate}}</mat-error>
  </mat-form-field>
  <app-international-phone class="flex1" id="phone_number" 
    [disabled]="disabledPhone" [newStyles]="true" [newBlueLightStyle]="false"
    (phoneChanged)="onPhoneChanged($event)" [validate]="validate"
    [value]="phone"  
  ></app-international-phone>

</div>